import { useEffect, useRef } from 'react';

export default function useKeepAwake(enabled: boolean = true): void {
    const wakeLockRef = useRef<WakeLockSentinel | null>(null);
    const videoRef = useRef<HTMLVideoElement | null>(null);

    useEffect(() => {
        let isActive = true;

        const requestWakeLock = async () => {
            if (!enabled) return;
            try {
                if ('wakeLock' in navigator) {
                    wakeLockRef.current = await navigator.wakeLock.request('screen');
                    const handleVisibilityChange = async () => {
                        if (document.visibilityState === 'visible' && isActive) {
                            try {
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                wakeLockRef.current = await (navigator as any).wakeLock.request('screen');
                            } catch (err) {
                                console.warn('Wake Lock re-request failed:', err);
                            }
                        }
                    };
                    document.addEventListener('visibilitychange', handleVisibilityChange);
                    return () => {
                        document.removeEventListener('visibilitychange', handleVisibilityChange);
                    };
                } else {
                    const video = document.createElement('video');
                    video.src = '/assets/keep-awake.mp4';
                    video.loop = true;
                    video.muted = true;
                    video.playsInline = true;
                    video.style.position = 'fixed';
                    video.style.bottom = '0';
                    video.style.left = '0';
                    video.style.width = '1px';
                    video.style.height = '1px';
                    video.style.opacity = '0';
                    videoRef.current = video;
                    document.body.appendChild(video);
                    try {
                        await video?.play();
                    } catch (err) {
                        console.warn('Fallback video failed to play:', err);
                    }
                }
            } catch (err) {
                console.error('Wake Lock error:', err);
            }
        };

        requestWakeLock();

        return () => {
            isActive = false;
            if (wakeLockRef.current) {
                wakeLockRef.current.release().catch(() => {});
                wakeLockRef.current = null;
            }
            if (videoRef.current) {
                videoRef.current?.pause();
                videoRef.current.remove();
                videoRef.current = null;
            }
        };
    }, [enabled]);
}

